export function AnalyticsPage() {
  const monthlySales = [
    { month: "Nov", revenue: 95000, orders: 210 },
    { month: "Dec", revenue: 148000, orders: 342 },
    { month: "Jan", revenue: 112000, orders: 265 },
    { month: "Feb", revenue: 87000, orders: 198 },
    { month: "Mar", revenue: 134000, orders: 310 },
    { month: "Apr", revenue: 162000, orders: 389 },
  ];

  const topProducts = [
    { name: "Polki Bridal Necklace", units: 48, revenue: 911952 },
    { name: "Kundan Choker Set", units: 67, revenue: 535933 },
    { name: "Temple Gold Earrings", units: 112, revenue: 503888 },
    { name: "Pearl Drop Earrings", units: 89, revenue: 311211 },
    { name: "Gold Bangle Set", units: 54, revenue: 269946 },
  ];

  const maxRevenue = Math.max(...monthlySales.map((m) => m.revenue));
  const maxProductRev = Math.max(...topProducts.map((p) => p.revenue));

  const stats = [
    { label: "Total Revenue (6M)", value: "Rs 7,38,000", change: "+18%", up: true },
    { label: "Avg Order Value", value: "Rs 2,450", change: "+5%", up: true },
    { label: "Conversion Rate", value: "3.8%", change: "-0.2%", up: false },
    { label: "Repeat Customers", value: "42%", change: "+7%", up: true },
  ];

  return (
    <div className="d-grid gap-4">
      {/* Summary Stats */}
      <div className="row g-3">
        {stats.map((s) => (
          <div className="col-12 col-md-6 col-xl-3" key={s.label}>
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body">
                <p className="text-muted mb-1 small">{s.label}</p>
                <h4 className="mb-1">{s.value}</h4>
                <span className={`badge ${s.up ? "text-bg-success" : "text-bg-danger"}`}>
                  {s.change} vs last period
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Monthly Revenue Bar Chart */}
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white">
          <h5 className="mb-0">Monthly Revenue</h5>
        </div>
        <div className="card-body">
          <div className="d-flex align-items-end gap-3 an-bar-wrap">
            {monthlySales.map((m) => (
              <div key={m.month} className="d-flex flex-column align-items-center flex-grow-1 gap-1 h-100 justify-content-end">
                <small className="text-muted" className="an-bar-label">
                  Rs {(m.revenue / 1000).toFixed(0)}k
                </small>
                <div
                  className="bg-primary rounded-top w-100"
                  style={{
                    height: `${(m.revenue / maxRevenue) * 140}px`,
                    minHeight: "8px",
                    transition: "height 0.3s ease",
                  }}
                />
                <small className="fw-semibold text-muted">{m.month}</small>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Orders Volume */}
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white">
          <h5 className="mb-0">Monthly Orders</h5>
        </div>
        <div className="card-body">
          <div className="d-flex align-items-end gap-3" className="an-bar-wrap-sm">
            {monthlySales.map((m) => (
              <div key={m.month} className="d-flex flex-column align-items-center flex-grow-1 gap-1 h-100 justify-content-end">
                <small className="text-muted" className="an-bar-label">{m.orders}</small>
                <div
                  className="rounded-top w-100"
                  style={{
                    height: `${(m.orders / Math.max(...monthlySales.map((x) => x.orders))) * 100}px`,
                    minHeight: "8px",
                    backgroundColor: "#20c997",
                  }}
                />
                <small className="fw-semibold text-muted">{m.month}</small>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Top Products */}
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white">
          <h5 className="mb-0">Top Products by Revenue</h5>
        </div>
        <div className="card-body d-grid gap-3">
          {topProducts.map((p, i) => (
            <div key={p.name}>
              <div className="d-flex justify-content-between mb-1">
                <span className="small fw-semibold">
                  <span className="text-muted me-2">#{i + 1}</span>
                  {p.name}
                </span>
                <span className="small text-muted">
                  Rs {p.revenue.toLocaleString()} · {p.units} units
                </span>
              </div>
              <div className="progress" className="an-progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${(p.revenue / maxProductRev) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
